<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15">
        <div class="bold9 size20 color1">
          系统公告详情页
          <!-- <span style="font-size: 14px; color: #ccd9e9"> Bulletin Details</span> -->
        </div>
      </div>
      <!-- 内容 -->
      <div class="flex between">
        <!-- 列表 -->
        <div>
          <div class="listBox">
            <div style="font-size: 24px; color: #3b426b; margin-bottom: 7px">
              {{ SysAnnDetail.title }}
            </div>
            <span style="font-size: 14px; color: #ccd9e9; margin-right: 20px">{{
              SysAnnDetail.publishTime
            }}</span>
            <span style="font-size: 14px; color: #ccd9e9"
              >浏览量：{{ SysAnnDetail.views }}</span
            >
            <el-divider class="divider"></el-divider>
            <div class="ql-editor" v-html="SysAnnDetail.content"></div>
          </div>
        </div>
        <!-- 图片 -->
        <img
          style="width: 324px; height: 397px"
          src="../assets/imgs/gonggao.png"
          alt=""
        />
      </div>
    </div>

    <Footer class="mt-15" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: { Footer },

  data() {
    return {
      SysAnnDetail: {},
      did: null,
    };
  },
  created() {
    this.did = this.$route.query.id;
  },
  mounted() {
    this.getSystemDetail();
    this.viewsAdd();
  },
  methods: {
    //获取系统公告详情
    async getSystemDetail() {
      const { data: res } = await this.$axios.get(
        "/api/annInfo/getSysAnnDetail",
        {
          params: {
            annId: this.did,
          },
        }
      );
      if (res.code == 200) {
        this.SysAnnDetail = res.data;
      } else {
        console.log(res);
      }
    },
    //系统公告浏览量
    async viewsAdd() {
      const { data: res } = await this.$axios({
        url: "/api/annInfo/updateView",
        method: "put",
        params: {
          annId: this.did,
          annType: 1,
        },
      });
      console.log(res);
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.divider.el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 20px;
  background-color: #95b3db;
}
.listBox {
  width: 855px;
  min-height: 400px;
  background-color: #fff;
  padding: 32px 40px;
  box-sizing: border-box;
  position: relative;
}
</style>